import React from 'react';

import { VideoBlockData } from 'api/cms';
import { Body, H2 } from 'components/Text';
import { AmpVideo } from 'components/Video';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const VideoBlock = ({
  data: { headline, subtitle, videoUrl },
}: {
  data: VideoBlockData;
}) => (
  <>
    {headline && <H2>{headline}</H2>}
    {subtitle && (
      <Body
        dangerouslySetInnerHTML={{
          __html: subtitle,
        }}
      />
    )}
    <AmpVideo url={videoUrl} />
  </>
);

export default VideoBlock;
